<div class="message" [ngClass]="type">
  <nb-icon [icon]="icon"></nb-icon>
  {{ message | translate }}
</div>
